import { ReactNode } from 'react'

import { StatusIcon } from '@forto-dev/phoenix-ui-core/ship'

import { Notification, NotificationType } from '../domain/notification'

export const getIconForNotificationType = (type: NotificationType): ReactNode => {
  switch (type) {
    case 'reassurance':
      return <StatusIcon icon="Check" color="positive" />
    case 'deviationRisk':
      return <StatusIcon icon="WarningPlain" color="warning" />
    case 'deviation':
      return <StatusIcon icon="WarningPlain" color="negative" />
    case 'update':
      return <StatusIcon icon="Refresh" color="muted" />
    case 'message':
      return <StatusIcon icon="Feed" color="muted" />
  }
}

export const formatNotificationTopline = (notification: Notification) => {
  const shipperOrConsignee =
    notification.counterParty === 'shipper' && notification.shipperName
      ? notification.shipperName
      : notification.counterParty === 'consignee' && notification.consignee
        ? notification.consignee
        : undefined
  return [
    notification.customerReference,
    shipperOrConsignee,
    // Not displaying the transport type and incoterm for now because the sidebar doesn't have enough space
    // notification.transportType?.toUpperCase(),
    // notification.incoterm,
  ]
    .map((item) => item ?? '')
    .filter(Boolean)
}
